module.exports = "/_next/static/images/Hero@2x-edf64153d061b940bed61c26018f9dc5.png";